module.exports = __webpack_public_path__ + "static/media/Donut.e9f0b91d.mkv";